import React from "react";
import PropTypes from "prop-types";

import DownloadMessage from "core/DownloadMessage";
import AttributionBasic from "core/AttributionBasic";
import DownloadPhotoButton from "./DownloadPhotoButton";

import { Spacer } from "./styles";

import { PhotoDownloadType } from "js/graphql";

const BasicDownloadSection = ({ photo }) => (
    <>
        <Spacer>
            <DownloadMessage photo={photo} />
        </Spacer>
        <Spacer>
            <AttributionBasic
                type="photo"
                title={photo.title}
                creator={photo.creator.name}
            />
        </Spacer>
        <DownloadPhotoButton
            downloadType={PhotoDownloadType.Basic}
            photoId={photo.id}
        >
            Download JPG
        </DownloadPhotoButton>
    </>
);

BasicDownloadSection.propTypes = {
    photo: PropTypes.object.isRequired
};

export default BasicDownloadSection;
